exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Cyb5RCzk-gWPlpiAoHEXR{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.RKFl-TUsdXTE7ZZWxFGwX{overflow-y:auto;overflow-x:hidden;-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}.laGnUXZu6QC88ONZDEBcE{-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2CTEj85tM6HtPskWwBc8l2,.laGnUXZu6QC88ONZDEBcE{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto}._2CTEj85tM6HtPskWwBc8l2{width:100%}.BVgxayg_IGpXi5g7S77GK{position:absolute;width:100%}html[dir] .BVgxayg_IGpXi5g7S77GK{background-color:\"[theme:neutralLight, default:#eaeaea]\"}.MpU1YknkwcMD_S7VK6Mg1{height:60px}html[dir] .MpU1YknkwcMD_S7VK6Mg1{background:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"container": "_3Cyb5RCzk-gWPlpiAoHEXR",
	"outerScrollContainer": "RKFl-TUsdXTE7ZZWxFGwX",
	"wrapperDiv": "laGnUXZu6QC88ONZDEBcE",
	"draggableDiv": "_2CTEj85tM6HtPskWwBc8l2",
	"rowWrapper": "BVgxayg_IGpXi5g7S77GK",
	"spinnerPlaceHolder": "MpU1YknkwcMD_S7VK6Mg1"
};